import Footer from "app/pages/.shared/Footer/Footer";

/* eslint-disable react/prop-types */
export default props => <Footer {...props} />;
